function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.8 9.9l-3.9 11.8h-1.5l3.9-11.8h1.5zM8 9.9H6.5l2.4 7.4h1.5L8 9.9zm10.9 9.5l-1.6-5.1h-1.5l2.4 7.4h1.5l3.9-11.8H22l-3.1 9.5zM29.5 15c0 8-6.5 14.5-14.5 14.5S.5 23 .5 15 7 .5 15 .5 29.5 7 29.5 15zm-1.2 0c0-7.3-6-13.3-13.3-13.3-7.3 0-13.3 6-13.3 13.3 0 7.3 6 13.3 13.3 13.3 7.3 0 13.3-6 13.3-13.3z"
})));